import React from 'react'
import { TextField } from '@material-ui/core'
import { useField } from 'formik'

type TextFieldProps = {
  disabled?: boolean
  label?: string
  multiline?: boolean
  name: string
  onBlur?: (e) => void
  placeholder?: string
  rowsMax?: number
  rows?: number
  style?: {}
  type?: string
  onChange?: (e) => void
  autoComplete?: string
  inputProps?: any
  className?: any
}

const ValidatedTextField = (props: TextFieldProps) => {
  const {
    className,
    disabled,
    label,
    multiline,
    name,
    placeholder,
    rowsMax,
    type,
    style,
    onChange,
    onBlur,
    rows,
    autoComplete,
    inputProps,
  } = props

  const [field, meta] = useField(name)

  const currentOnChange = onChange ? onChange : field.onChange
  const currentOnBlur = onBlur ? onBlur : field.onBlur

  const error = !!(meta.error && meta.touched)
  const helperText = error ? meta.error : null

  return (
    <TextField
      error={error}
      label={label}
      type={type}
      variant="outlined"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={inputProps}
      onChange={currentOnChange}
      onBlur={currentOnBlur}
      multiline={multiline}
      name={name}
      value={meta.value}
      rowsMax={rowsMax ? rowsMax : 0}
      fullWidth={true}
      style={style}
      disabled={disabled}
      helperText={helperText}
      placeholder={placeholder}
      rows={`${rows}`}
      autoComplete={autoComplete}
      className={className}
      margin="normal"
    />
  )
}

export default ValidatedTextField
